import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { deleteDialog } from 'src/app/shared/dialog';
import { Agent, AGENT_PERMISSIONS, LlmModel, ProjectOption } from '../../models/ai-agents.models';
import { AgentPermissionsService } from '../../services/agent-permissions.service';
import { AiAgentsApiService } from '../../services/ai-agents-api.service';

@Component({
  selector: 'app-ai-agents-list-page',
  templateUrl: './agents-list-page.component.html',
  styleUrls: ['../../ai-agents.shared.css'],
})
export class AgentsListPageComponent implements OnInit {
  readonly P = AGENT_PERMISSIONS;

  agents: Agent[] = [];
  projects: ProjectOption[] = [];
  models: LlmModel[] = [];
  projectFilter = '';
  search = '';
  loading = false;

  constructor(
    private api: AiAgentsApiService,
    public perms: AgentPermissionsService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.projectFilter = this.route.snapshot.queryParamMap.get('projectId') || '';
    this.api.listProjects().subscribe({ next: (list) => (this.projects = list), error: () => (this.projects = []) });
    if (this.perms.has(this.P.modelList)) {
      this.api.listModels().subscribe({ next: (list) => (this.models = list || []) });
    }
    this.load();
  }

  get filtered(): Agent[] {
    const q = this.search.trim().toLowerCase();
    if (!q) return this.agents;
    return this.agents.filter((a) => (a.name || '').toLowerCase().includes(q) || a.id.includes(q));
  }

  projectName(id: string): string {
    return this.projects.find((p) => p.projectId === id)?.name || id;
  }

  modelName(id: string): string {
    return this.models.find((m) => m.id === id)?.displayName || id;
  }

  onProjectChange(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { projectId: this.projectFilter || null },
      replaceUrl: true,
    });
    this.load();
  }

  load(): void {
    this.loading = true;
    this.api.listAgents(this.projectFilter.trim() || null).subscribe({
      next: (list) => {
        this.agents = list || [];
        this.loading = false;
      },
      error: () => (this.loading = false),
    });
  }

  create(): void {
    this.router.navigate(['/ai-agents/agents/new'], {
      queryParams: { projectId: this.projectFilter || null },
    });
  }

  open(a: Agent, tab?: string): void {
    this.router.navigate(['/ai-agents/agents', a.id], { queryParams: tab ? { tab } : {} });
  }

  conversations(a: Agent): void {
    this.router.navigate(['/ai-agents/conversations'], { queryParams: { projectId: a.projectId, agentId: a.id } });
  }

  async remove(a: Agent): Promise<void> {
    const confirm = await deleteDialog();
    if (!confirm.isConfirmed) {
      return;
    }
    this.api.deleteAgent(a.id).subscribe({ next: () => this.load() });
  }
}
